<template>
    <div>
        <div>
            <h4>Acceso vigilantes</h4>
        </div>
        <button class="btn btn-confirm" @click="confirmVigilanceAccess">
            Confirmar Acceso
        </button>
        <button class="btn btn-danger" @click="rejectVigilanceAccess">
            Denegar Acceso
        </button>
        <div v-if="!!access">Acceso hasta: {{ access | datetime }}</div>
        <div v-else>[NO ACCESS]</div>
    </div>
</template>
<script>
import { cookies } from '../../../mixin'
export default {
    mixins: [cookies],
    data() {
        return {
            access: '',
        }
    },
    methods: {
        async confirmVigilanceAccess() {
            const { data } = await repo.post('web-access')
            if (data.status) {
                toastr.success('Acceso concedido por 1 año')
                this.access = data.result.expiration
            } else {
                toastr.error(data.msg)
            }
        },
        async rejectVigilanceAccess() {
            const { data } = await repo.delete('web-access')
            if (data.status) {
                this.access = ''
                toastr.success('Acceso revocado')
            }
        },
        async validateDeviceAccess() {
            const { data } = await repo.get('web-access')
            if (data.status) {
                this.access = data.result
            } else {
                this.access = ''
            }
        },
    },
    created() {
        this.validateDeviceAccess()
        // debugger
        // const deviceAccess = this.getCookie('device_access')
        // console.log(deviceAccess)
    },
}
</script>
